import { Octokit } from '@octokit/core';
import { getUserDetails } from './gitAuth';
export interface GitBranch {
  name: string;
  commit: { sha: string; url: string };
  protected: boolean;
  protection: {
    required_status_checks: {
      enforcement_level: string;
      contexts: string[];
    };
  };
  protection_url: string;
}
export const getGitBranches = async (
  token: string,
  repoName: string,
  pageNum: number = 1
): Promise<GitBranch[]> => {
  // Octokit.js
  // https://github.com/octokit/core.js#readme
  const octokit = new Octokit({
    auth: token
  });
  const gitUserDetails = await getUserDetails(token);
  const owner = gitUserDetails.login;
  const res = await octokit.request(
    `GET /repos/${owner}/${repoName}/branches?per_page=100&page=${pageNum}`,
    {
      owner: owner,
      repo: repoName,
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
};

export const getAllGitBranches = async (
  token: string,
  repoName: string
): Promise<GitBranch[]> => {
  let pageNum = 1;
  let gitBranchRes = await getGitBranches(token, repoName, pageNum);
  let allGitBranches = [...gitBranchRes];
  while (gitBranchRes.length === 100) {
    pageNum++;
    gitBranchRes = await getGitBranches(token, repoName, pageNum);
    allGitBranches = allGitBranches.concat(gitBranchRes);
  }
  return allGitBranches;
};
export const createNewBranch = async (
  token: string,
  repoName: string,
  newBranchName: string,
  currentBranchName: string
) => {
  // https://stackoverflow.com/questions/9506181/github-api-create-branchgit add *
  const octokit = new Octokit({
    auth: token
  });
  const gitUserDetails = await getUserDetails(token);
  const owner = gitUserDetails.login;
  const currentBranchDetails = await getBranchDetails(
    token,
    owner,
    repoName,
    currentBranchName
  );
  const res = await octokit.request(
    `POST /repos/${owner}/${repoName}/git/refs`,
    {
      owner: owner,
      repo: repoName,
      ref: `refs/heads/${newBranchName}`,
      sha: currentBranchDetails.commit.sha,
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
};

export const getBranchDetails = async (
  token: string,
  owner: string,
  repoName: string,
  branch: string
): Promise<any> => {
  const octokit = new Octokit({ auth: token });
  // getting branch details for commit
  const res = await octokit.request(
    `GET /repos/${owner}/${repoName}/branches/${branch}`,
    {
      owner: owner,
      repo: repoName,
      branch: branch,
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
};
